import React from "react";

// import  img from "../../../"

export default function () {
  return (
    <div className="py-20 h-336px md:h-284px bg-cta">
      <h4 className="text-center h4-24-bold md:h3-36-bold md:text-4xl w-310px md:w-full mx-auto font-bold text-white  font-mont">
        A trusted collaboration network
      </h4>
      <p className="p-16-normal text-center text-light-minor w-350px md:w-476px mx-auto mt-4 font-inter">
        Our vision is to build a decentralized, trusted collaboration network.
        Collaboration data will be stored on blockchain, while credit will be
        build on this. This will empower the credible profiles and reduce the
        cost for collaborations.
      </p>
    </div>
  );
}
